import { useContext } from 'react';
import { CombinedFeedContext } from '../../../../context/CombinedFeedContext';

// components
import NotificationBar from  '@/components/elements/languages/NotificationBar';
import { LoadingSpinner } from 'thrive-components';
import AllAvailableContentAsSource from  '@/components/elements/combinedFeed/AllAvailableContentAsSource';
import EditSourceListsView from  '@/components/elements/combinedFeed/EditSourceListsView';
import Information from  '@/components/elements/global/Information';

// interfaces
import { modeType } from  '@/interfaces/CombinedFeed';

//styling
import  '@/css/lists/list.scss';



const SourceListsTab = () => {
    const {notificationDetails, isLoadingSL, feedMode, handleModalOpen, isAlteringSL, hasListId} = useContext(CombinedFeedContext)

    return (<>
        <div className={`source-list-container ${isLoadingSL || isAlteringSL ? "loading-source-list-tab" : ""}`} data-testid="source-list-container">
            {isLoadingSL
                ?   <>{hasListId  
                        ?  <LoadingSpinner size={10} />
                        :  <Information text={'You cannot add content to an unsaved Combined Feed'} style={undefined} />
                    }</>
                :   <>{feedMode === modeType.all
                        ?   <AllAvailableContentAsSource onButtonClick={() => handleModalOpen(true)} />
                        :   <EditSourceListsView />
                    }</>
            }
        </div>

        <NotificationBar show={notificationDetails.show} notificationStatus={notificationDetails.status} msg={notificationDetails.message} />
    </>)
}

export default SourceListsTab